export interface Cashier {
    id: string;
    name: string;
    lastName: string;
    username: string;
    /**
     * profiles.avatar_base64 (data URI). available-cashiers todavia no lo
     * devuelve; hasta que su SQL haga LEFT JOIN profiles, se cae a iniciales.
     */
    avatarBase64?: string;
}

export const getFullName = (c: Cashier): string =>
    `${c.name} ${c.lastName}`.trim();

export const getInitials = (c: Cashier): string => {
    const first = (c.name || '').trim().charAt(0);
    const last = (c.lastName || '').trim().charAt(0);
    return `${first}${last}`.toUpperCase() || '?';
};

const AVATAR_COLORS = ['#E07A5F', '#3D405B', '#81B29A', '#B08968', '#9B72AA', '#4F8A8B'];

/** Color estable: el mismo cajero sale siempre igual, sin guardar nada. */
export const getAvatarColor = (c: Cashier): string => {
    const key = String(c.id);
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};
